import React, { useEffect } from 'react';
import { withLocalize } from "react-localize-redux";
import { useHistory } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { removeToken } from '../redux/actions';
import { useDispatch } from 'react-redux';
import ajaxService from '../services/ajax-service';
import { Button, Space } from 'antd-mobile';

const Navigation = ({ translate, activeLanguage, setActiveLanguage }) => {
    const [login, setLogin] = useAuth();
    const history = useHistory();
    const dispatch = useDispatch();

    const logoutUser = async () => {
        let response = await ajaxService.post('logout');

        if (response) {
            dispatch(removeToken());
            setLogin(false);
            localStorage.removeItem('isLoggedIn');
            history.push('/home');
        }
    }

    useEffect(() => {
        const savedLang = localStorage.getItem('language');
        if (savedLang && savedLang !== activeLanguage.code) {
            setActiveLanguage(savedLang);
        }
    }, [activeLanguage.code, setActiveLanguage]);

    const handleLanguageChange = (langCode) => {
        setActiveLanguage(langCode);
        localStorage.setItem('language', langCode);
    };


    const renderAuth = () => {
        if (login) {
            return (
                <Space wrap style={styles.section}>
                    <Button
                        size="mini"
                        color="primary"
                        onClick={() => history.push('/masjid-list')}
                    >
                        {translate('masajid')}
                    </Button>
                    <Button
                        size="mini"
                        color="danger"
                        onClick={logoutUser}
                    >
                        {translate('logout')}
                    </Button>
                </Space>
            );
        } else {
            return (
                <Space wrap>
                    <Button
                        size="mini"
                        color="primary"
                        onClick={() => history.push('/login')}
                    >
                        {translate('login')}
                    </Button>
                    <Button
                        size="mini"
                        color="primary"
                        onClick={() => history.push('/register')}
                    >
                        {translate('register')}
                    </Button>
                </Space>
            );
        }
    }

    return (
        <nav style={styles.navbar}>
            <Space wrap style={styles.section}>
                <Button
                    size="mini"
                    color="primary"
                    onClick={() => history.push('/home')}
                >
                    {translate('home')}
                </Button>
            </Space>

            <Space wrap style={styles.section}>
                {renderAuth()}
            </Space>

            <Space wrap style={styles.section}>
                <Button
                    size="mini"
                    fill={activeLanguage.code === 'en' ? 'solid' : 'outline'}
                    color="primary"
                    onClick={() => handleLanguageChange('en')}
                >
                    English
                </Button>
                <Button
                    size="mini"
                    fill={activeLanguage.code === 'ur' ? 'solid' : 'outline'}
                    color="primary"
                    onClick={() => handleLanguageChange('ur')}
                >
                    اردو
                </Button>
            </Space>
        </nav>
    );
}

const styles = {
    navbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 20px',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
        borderBottom: '1px solid #ddd',
    },
    section: {
        display: 'flex',
        gap: '12px',
        alignItems: 'center'
    }


};

export default withLocalize(Navigation);
